var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_64_28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.218 0H3.78199C1.69333 0 0 1.69333 0 3.78199V31.218C0 33.3067 1.69333 35 3.78199 35H31.218C33.3067 35 35 33.3067 35 31.218V3.78199C35 1.69333 33.3067 0 31.218 0ZM19.5504 30.7674V21.368H22.6851L23.2812 17.4795H19.5504V14.9566C19.5504 13.8928 20.0714 12.8556 21.7429 12.8556H23.4389V9.54545C23.4389 9.54545 21.8992 9.28258 20.4278 9.28258C17.3552 9.28258 15.3472 11.1452 15.3472 14.5162V17.4795H11.9318V21.368H15.3472V30.7674C8.9166 29.7582 3.99776 24.1934 3.99776 17.4795C3.99776 10.0507 10.02 4.02848 17.4488 4.02848C24.8776 4.02848 30.8998 10.0507 30.8998 17.4795C30.8998 24.1934 25.981 29.7582 19.5504 30.7674Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_64_28"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.2a0011159d112896ce97635c3b648eb5.svg";
export { ForwardRef as ReactComponent };